import React from "react";
import PropTypes from "prop-types";
import Modal from "react-bootstrap/Modal";
import { Button } from "react-bootstrap";

const YaraEditorModal = props => {
  const {
    children,
    show = true,
    title,
    onHide = () => undefined,
    className = "",
    fullscreen,
    backdropClassName
  } = props;
  return (
    <Modal
      show={show}
      onHide={onHide}
      className={className}
      fullscreen={fullscreen}
      backdropClassName={backdropClassName}
    >
      <Modal.Header>
        <Modal.Title>{title}</Modal.Title>
        <Button onClick={onHide} data-testid="yara_modal_close_button">
          Close
        </Button>
      </Modal.Header>
      <Modal.Body style={{ height: "100%" }}>{children}</Modal.Body>
    </Modal>
  );
};

YaraEditorModal.propTypes = {
  title: PropTypes.string,
  show: PropTypes.bool,
  fullscreen: PropTypes.bool,
  children: PropTypes.node,
  onHide: PropTypes.func,
  className: PropTypes.string,
  backdropClassName: PropTypes.string
};

export default YaraEditorModal;
